module.exports = __webpack_public_path__ + "img/a9.4ef125d5.png";